// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"styles":"8b3fae20f3988ba784c8","default":"4165c7c1feeaf9faab78","dark":"8abc9dae0d49bda13e5c"}[chunkId] + ".css";
};